const authorizationKey = 'token'

export function getAuthorization() {
  return localStorage.getItem(authorizationKey)
}

export function getUser() {
  return localStorage.getItem('user')
}

export function setAuthorization(authorization) {
  return localStorage.setItem(authorizationKey, authorization)
}

export function removeAuthorization() {
  return localStorage.removeItem(authorizationKey)
}
